import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';
import { formatMoneda } from '../util/varios';
import useTable from "../components/useTable"
// import Controls from "../components/controls/Controls";
// 
import {
    TableBody, TableRow, TableCell,
    // InputAdornment 
} from '@mui/material'
    ;
import axios from "axios";
import { Dimmer } from '../components/spinner';


const CatalogoObraRealizada = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [recordsd, setRecordsd] = useState([]);
    const [values, setValues] = useState({});
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);
    const headCells = [
        { id: 'idobra', label: 'CODIGO', width: '60px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: 'descripcion', label: 'DESCRIPCION', width: '300px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: 'monto', label: 'MONTO', width: '120px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" }

    ]
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);
    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        return items.filter(x => {
                            if (x.idobra.includes(target.value)
                                || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                                || formatMoneda(x.montoto.toString().replace('.', ','), ',', '.', 2).includes(target.value)) {
                                return x;
                            }
                        });
                    });
                }
            }
        })
    }

    const seleccionarFila = (index) => (event) => {
        setItemSelect(index);
        setActivo(false);
        var idobra = recordsAfterPagingAndSorting()[index].idobra;
        var descripcion = recordsAfterPagingAndSorting()[index].descripcion;
        var monto = recordsAfterPagingAndSorting()[index].monto;
        var proyecto = recordsAfterPagingAndSorting()[index].proyecto;
        var datos = [];
        datos.push({
            idobra,
            descripcion,
            monto,
            proyecto

        })
        setValues(datos);
    };
    const seleccionarLista = (index) => (event) => {
        blanquear();
        props.onHideAceptaCatalogo(values)
    };
    
    const seleccionarObras = () => {
        let endpoint;

        if (parseInt(espiritu) === 7) {
            endpoint = `${op.conexion}/api/contabilidadfis/catalogoobra1?idefiscal=${idefiscal}`;

        } else {
            endpoint = `${op.conexion}/api/contabilidadfis/catalogoobra2?idefiscal=${idefiscal}`;

        }
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            }
        }).then(function (response) {
            if (response.status === 200) {
                setActivate(false);
                setRecords(response.data);
            }
        }).catch(function (error) {
            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);
        })
    }
    const blanquear = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setRecordsd([]);
        setFilterFn({ fn: items => { return items; } });
    }
    const handleCloseMensa = () => {
        setMostrar(false);
    }
    const cancelar = () => {
        blanquear();
        props.onHideCancelaCatalogo();
    }

    
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarObras()
            }}>
            <Modal.Header className='azulGradiant px-4 py-2'>
                <Modal.Title className='fs-4 fw-bold m-0 text-light'>
                    Seleccionar Obras.
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="col-6 input-group input-group-sm m-0 mb-2 p-0">
                    <input type='text'
                        onChange={handleSearch}
                        className="form-control rounded-pill" />
                </div>
                <div className="col-12 p-0 m-0">
                    <TblContainer >
                        <TblHead />
                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idobra} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{
                                            fontSize: "10px",
                                            textAlign: "left",
                                            width: "60px",
                                            verticalAlign: "middle"
                                        }}>
                                            {item.idobra}
                                        </td>
                                        <td style={{
                                            fontSize: "10px",
                                            textAlign: "left",
                                            width: "300px",
                                            verticalAlign: "middle"
                                        }}>
                                            {item.descripcion}
                                        </td>
                                        <td style={{
                                            fontSize: "10px",
                                            textAlign: "right",
                                            width: "120px",
                                            verticalAlign: "middle"
                                        }}>
                                            {formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </TblContainer>
                    <TblPagination />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-primary rounded"
                    disabled={activo}
                    onClick={seleccionarLista()}>
                    <i className="fas fa-check-circle"> Aceptar</i>
                </button>
                <button ref={btnCancela}
                    onClick={cancelar}
                    className="btn bg-light rounded btn-sm">
                    <i className="fa"> Cancelar</i>
                </button>
            </Modal.Footer>
        </Modal>
    );
}
export default CatalogoObraRealizada;